import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { get, put } from '@truefit/http-utils';
import { Role } from '@/types/user';

// Roles held by the user directly, on top of their group's. Both endpoints are
// platform-admin only: these roles apply in every org the user belongs to.

export const useUserRolesQuery = (userId: number) =>
  useQuery<Role[]>({
    queryKey: ['UserRoles', userId],
    queryFn: async () => {
      const { data } = await get<Role[]>(`/v1.0/users/${userId}/roles`);
      return data;
    },
  });

export const useUpdateUserRolesMutation = (userId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (roleIds: number[]): Promise<void> => {
      await put<void>(`/v1.0/users/${userId}/roles`, { roleIds });
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['UserRoles', userId] }),
  });
};
